import { render, staticRenderFns } from "./SCDetailView.vue?vue&type=template&id=e40202a6"
import script from "./SCDetailView.vue?vue&type=script&lang=js"
export * from "./SCDetailView.vue?vue&type=script&lang=js"
import style0 from "./SCDetailView.vue?vue&type=style&index=0&id=e40202a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports